<template>
  <div>
    <md-table class="paginated-table table-striped table-hover" md-card v-model="value">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell
          :md-label="header.name"
          v-for="(header, key) in tableHeaders"
          :key="key"
        >{{ header.prefix }} {{ item[header.value] }}</md-table-cell>

        <md-table-cell md-label="Documentos" v-if="tableActions && tableActions.length">
          <span v-for="action in tableActions" :key="action.icon">
            <md-button
              v-if="item[action.value]"
              class="md-just-icon md-info md-simple"
              style="margin-right: 5px"
              @click.native="action.exe(item[action.value])"
            >
              <md-icon>{{ action.icon }}</md-icon>
            </md-button>
          </span>
        </md-table-cell>
        <md-table-cell class="status-cell" md-label="Estatus">
          <div class="outlined-field" style="max-width: 320px;">
            <md-field>
              <md-select
                v-model="item.advanceType"
                :disabled="disableSelectStatus(item)"
                @input="writeStatus($event, item)"
              >
                <md-option
                  v-for="status in filteredStatus(item)"
                  :key="status.name"
                  :value="status.name"
                >{{ status.name }}</md-option>
              </md-select>
            </md-field>
          </div>
          <div
            v-if="item.advanceType === 'Saldado'"
            class="outlined-field-picker"
            style="max-width: 320px;"
          >
            <md-field>
              <label for="dateOccurred">
                <md-icon>calendar_today</md-icon>
                {{ item.settlementDate ? "" : "Fecha de saldado" }}
              </label>
              <datetime
                style="width: 100%"
                input-style="border: none; outline:none; width: 100%"
                type="date"
                input-class="Object"
                title="Fecha de saldado"
                value-zone="America/Mexico_City"
                :phrases="{ ok: 'Ok', cancel: 'Cancelar' }"
                v-model="item.settlementDate"
                :disabled="item.lastStatus !== 'Aprobado'"
                @input="writeDate($event, item)"
              ></datetime>
            </md-field>
          </div>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <div v-if="hasModifiedAdvances" class="md-layout md-alignment-center-right">
      <md-button class="md-info" @click="submitAdvance">Guardar cambios</md-button>
      <md-button class="md-danger" @click="$emit('resetData')">Cancelar</md-button>
    </div>
  </div>
</template>

<script>
import usesAccountInfoMixin from "@/mixins/usesAccountInfo";
import urlUtility from "@/utils/assetURL";
import { isImageURL } from "@/utils";
import { mapPermissions } from "@/plugins/accountPermissions/";

export default {
  name: "AdvancesTable",
  mixins: [usesAccountInfoMixin],
  props: {
    value: {
      type: Array,
      required: true,
    },
    fetchedStatus: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tableHeaders: [
        {
          name: "Cantidad",
          value: "amount",
          prefix: "$",
          sort: true,
          numeric: true,
        },
        {
          name: "Porcentaje",
          value: "percentage",
          sort: true,
          numeric: true,
        },
        {
          name: "Solicitante",
          value: "userRequesting",
          sort: true,
          numeric: false,
        },
        {
          name: "Fecha",
          value: "date",
          sort: false,
          numeric: false,
        },
        {
          name: "Comentario",
          value: "comment",
          sort: false,
          numeric: false,
        },
      ],
      tableActions: [
        {
          icon: "picture_as_pdf",
          value: "pdf",
          exe: this.seeFile,
          tooltip: "Ver PDF",
        },
        {
          icon: "attachment",
          value: "xml",
          exe: this.seeFile,
          tooltip: "Ver xml",
        },
      ],
    };
  },
  computed: {
    ...mapPermissions("PurchaseRequisition", "advances", ["delete"]),
    ...mapPermissions("PurchaseRequisition", "amountapprovedadvances", [
      "add",
      "change",
    ]),
    advanceStatus() {
      const allowedStatus = ["capturado", "aprobado", "cancelado", "saldado"];
      return this.fetchedStatus
        .filter(({ slug }) => allowedStatus.some((status) => status === slug))
        .map((s) => {
          let additional = { permission: true, codename: null };
          switch (s.slug) {
            case "aprobado":
              additional.codename = "approved";
              additional.permission = this.$can(
                "approve_advance",
                "PurchaseRequisition",
                "advances"
              );
              break;
            case "cancelado":
              additional.codename = "refused";
              additional.permission = this.$can(
                "cancel_advance",
                "PurchaseRequisition",
                "advances"
              );
              break;
            case "saldado":
              additional.codename = "settled";
              additional.permission = this.$can(
                "settle_advance",
                "PurchaseRequisition",
                "advances"
              );
              break;
            default:
              break;
          }

          return {
            ...s,
            ...additional,
          };
        });
    },
    hasModifiedAdvances() {
      return this.value.some(({ changed }) => changed);
    },
  },
  methods: {
    filteredStatus({ lastStatus }) {
      const statusLowerCase = lastStatus ? lastStatus.toLowerCase() : "";
      const allowedStatus = {
        aprobado: ["cancelado", "saldado", "aprobado"],
        capturado: ["aprobado", "cancelado", "capturado"],
        saldado: ["saldado"],
        cancelado: ["cancelado"],
      };
      const { advanceStatus } = this;
      return advanceStatus.filter(({ slug }) =>
        allowedStatus[statusLowerCase].includes(slug)
      );
    },
    disableSelectStatus({ advanceType = "" }) {
      const statusLowerCase = advanceType ? advanceType.toLowerCase() : "";
      const notAllowed = ["saldado"];
      const permissions = {
        aprobado: this.$can(
          "settle_advance",
          "PurchaseRequisition",
          "advances"
        ),
        capturado: this.$can(
          "approve_advance",
          "PurchaseRequisition",
          "advances"
        ),
        saldado: false,
        cancelado: false,
      };
      return (
        notAllowed.includes(statusLowerCase) || !permissions[statusLowerCase]
      );
    },
    submitAdvance() {
      this.$emit("changeStatusItem");
    },
    seeFile(file) {
      const cFile = urlUtility(file);
      if (!isImageURL(file)) {
        const win = window.open(cFile, "_blank");
        win.focus();
      }
    },
    writeStatus(e, advance) {
      const status = this.advanceStatus.find(({ name }) => name === e);
      advance.statusCodename = status.codename;
      advance.settlementDate = advance.settlementDate;
      advance.changed = e !== advance.lastStatus;
    },
    writeDate(e, advance) {
      const status = this.advanceStatus.find(
        ({ name }) => name === advance.advanceType
      );
      advance.statusCodename = status.codename;
      advance.settlementDate = e;
      advance.changed = e;
    },
  },
};
</script>

<style lang="scss" scoped>
h4 {
  margin-left: 10px;
}
.current-total-section {
  background-color: #dadada;
}
.no-advances {
  height: 100px;
}
.md-tooltip {
  z-index: 110;
}
.approve-row {
  background-color: rgb(108, 184, 108) !important;
}
.reject-row {
  background-color: rgb(228, 103, 103) !important;
}
.request-row {
  background-color: rgba(158, 158, 158, 0.473) !important;
}
.table-chip {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  border: none;
  padding: 5px 20px 5px 20px;
}

.outlined-field {
  padding: 0;
  max-width: 300px;
}
.status-cell {
  padding-top: 0;
  max-width: 300px;
}

.datetime {
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/Advances/TableAdvances.vue